import Icon from '@ant-design/icons';

const GoToSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon Placer">
        <g id="Vector" style={{ mixBlendMode: 'luminosity' }}>
          <path
            d="M11.677 3.78852L3.88 4.33985C3.82034 4.34427 3.76399 4.36968 3.7209 4.41277L2.7431 5.39056C2.66134 5.47232 2.72543 5.61153 2.84033 5.6027L10.0683 5.09225L3.60268 11.5579C3.55407 11.6065 3.55407 11.686 3.60268 11.7346L4.26559 12.3975C4.31421 12.4462 4.39376 12.4462 4.44237 12.3975L10.9069 5.93305L10.3964 13.161C10.3887 13.277 10.5268 13.34 10.6086 13.2582L11.6195 12.2473C11.6405 12.2263 11.6538 12.1976 11.6549 12.1677L12.2117 4.32327C12.2167 4.25177 12.2063 4.18002 12.1812 4.11288C12.1561 4.04574 12.1168 3.98476 12.0662 3.93408C12.0155 3.88339 11.9545 3.84417 11.8874 3.81906C11.8202 3.79395 11.7485 3.78354 11.677 3.78852Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export const GoToIcon = (props: any) => <Icon component={GoToSvg} {...props} />;
